<template>
  <div 
    v-show="currentlyVisible"
    class="position-relative"
  >
    <!-- Cropper -->
    <Cropper 
      v-if="imageContent"
      ref="cropperRef"
      :src="imageContent"
      :stencilResizable="false"
      :stencilMovable="false"
      :handlers="false"
      :stencil-props="{
          handlers: {},
          movable: false,
          resizable: false,
          aspectRatio: 1,
      }"
      :stencilSize="defaultSize"
      :resize-image="{
          adjustStencil: false
      }"
      backgroundClass="cropper-override"
      foregroundClass="cropper-override"
      image-restriction="stencil"
      :min-height="200"
      @change="generateImage"
      @ready="refreshCropper"
    />
    <!-- Red X Button -->
    <button 
      v-if="!forceShow"
      class="btn btn-danger close-btn"
      @click="onClose"
    >
      &times;
    </button>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue';
import { ref, nextTick } from 'vue';
import { Cropper } from 'vue-advanced-cropper';

const props = defineProps({
    imageContent: { type: String, required: false },
    callback: { type: Function, required: true },
    visible: { type: Boolean, required: false, default: true }
});

const forceShow = ref(false);

const currentlyVisible = computed(() => {
    if (forceShow.value) {
        return true;
    }

    return props.visible;
})

const cropperRef = ref(null);

const onClose = () => {
    props.callback(null, null);
};

const defaultSize = ({ boundaries }) => {
	return {
		width: boundaries.width,
		height: boundaries.height,
	}
}

const generateImage = () => {
    if (!props.imageContent) {
        return;
    }

    const res = cropperRef.value.getResult({
        mime: 'image/png'
    });

    const dataUrl = res.canvas.toDataURL('image/png', 0.9);

    forceShow.value = false;
    
    if (!res) {
        return;
    }

    props.callback(dataUrl, props.imageContent);
}

const refreshCropper = async () => {
    await nextTick();
    if (cropperRef.value) {
        cropperRef.value.refresh();
    }
}

watch(() => props.imageContent, async (newVal) => {
    if (newVal) {
        forceShow.value = true;
    }
});

</script>

<style lang="scss" scoped>
.close-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 10;
  border-radius: 100%;
  min-width: 28px;
  min-height: 28px;
  height: 28px;
  width: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>